module.exports = __webpack_public_path__ + "img/slide1_4.1f9ce8fe.png";